export default {
  ContactMethodFormField__ARIA: "Contact method",
  ContactMethodFormField__CALL_ME: "Call me (automated)",
  ContactMethodFormField__EMAIL_ME: "Email me",
  ContactMethodFormField__LABEL: "Contact method",
  ContactMethodFormField__TEXT_ME: "Text me",
};
